<footer id="footer">
    <div class="container">
        <div class="footer-upper section-pd-sm pb-20">
            <div class="row">
                <div class="col-lg-6 col-12">
                    <div class="footer-widget">
                        <h3>Über Trinka</h3>
                        <p>Trinka AI ist ein auf Datenschutz ausgerichtetes Tool zur Grammatikprüfung und Sprachoptimierung, das speziell für das akademische und technische Schreiben entwickelt wurde. Trinka unterstützt Fachleute und Akademiker dabei, Texte zu verfassen, die formell, prägnant und ansprechend sind. Die Enterprise-Lösungen von Trinka bieten vollen Funktionsumfang, vielfältige Integrationsmöglichkeiten sowie umfassende Kontrolle über die Daten und lassen sich individuell an Ihre Bedürfnisse anpassen.</p>
                    </div>
                </div>
                <div class="col-lg-6 col-12">
                    <div class="footer-widget">
                        <h3>Installieren für:</h3>
                        <ul class="install-for">
                            <li>
                                <div class="install-in-browser">
                                    <div class="icon text-center">
                                        <img src="assets/images/icons/NewWordAdd_in.svg" width="47" height="42" alt="word in - grammar checker" />
                                    </div>
                                    <span>MS Word für Windows</span>
                                </div>
                            </li>
                            <li>
                                <div class="install-in-browser">
                                    <div class="icon text-center">
                                        <img src="assets/images/icons/NewChromeFicon.svg" width="43" height="42" alt="word in - grammar checker" />
                                    </div>
                                    <span>Google Chrome</span>
                                </div>
                            </li>
                            <li>
                                <div class="install-in-browser">
                                    <div class="icon text-center">
                                        <img src="assets/images/icons/NewFirefoxFicon.svg" width="42" height="42" alt="word in - grammar checker" />
                                    </div>
                                    <span>Mozilla Firefox</span>
                                </div>
                            </li>
                            <li>
                                <div class="install-in-browser">
                                    <div class="icon text-center">
                                        <img src="assets/images/icons/EdgeWhite_BGAndOutline.svg" width="42" height="42" alt="word in - grammar checker" />
                                    </div>
                                    <span>Microsoft Edge</span>
                                </div>
                            </li>
                            <li>
                                <div class="install-in-browser">
                                    <div class="icon text-center">
                                        <img src="assets/images/icons/NewWordAdd_in.svg" width="47" height="42" alt="word in - grammar checker" />
                                    </div>
                                    <span>MS Word für macOS</span>
                                </div>
                            </li>
                            <li>
                                <div class="install-in-browser">
                                    <div class="icon text-center">
                                        <img src="assets/images/icons/windows.png" width="42" height="42" alt="windows app - grammar checker" />
                                    </div>
                                    <span>Windows-App</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="footer-grid">
                <div class="row">
                    <div class="col-6 col-sm-4 col-2">
                        <div class="footer-widget">
                            <h3>Produkt</h3>
                            <ul class="ftr-menu">
                                <li>
                                    <a [routerLink]="['/features/grammar-checker']">Grammatik & Sprache</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/features/proofread-file']">Textkorrektur</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/features/paraphraser']">Umformulierungstool</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/features/ai-studio/ai-assisted-writing']">/Ask</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/features/credits']">Credits für Trinka</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-12 col-sm-4 col-3">
                        <div class="row">
                            <div class="col-sm-12 col-6">
                                <div class="footer-widget">
                                    <h3>Enterprise Solutions</h3>
                                    <ul class="ftr-menu">
                                        <li>
                                            <a [routerLink]="['/enterprise']">Unternehmensintegrationen</a>
                                        </li>
                                        <li>
                                            <a [routerLink]="['/enterprise/academic-institutions']">Hochschulen</a>
                                        </li>
                                        <li>
                                            <a [routerLink]="['/local-invoice']">Rechnungsstellung und Zahlungen</a>
                                        </li>
                                        <li>
                                            <a [routerLink]="['/features/documark']">DocuMark</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-4">
                        <div class="row">
                            <div class="col-md-6 col-sm-4 col-12">
                                <div class="row">
                                    <div class="col-6 col-sm-12">
                                        <div class="footer-widget">
                                            <h3>Resources</h3>
                                            <ul class="ftr-menu">
                                                <li>
                                                    <a href="/case-study">Fallstudien</a>
                                                </li>
                                                <li>
                                                    <a href="/industry-engagements">Trinkas Engagement in der Branche</a>
                                                </li>
                                                <li>
                                                    <a href="https://www.trinka.ai/university-ai-policy-repository" target="_blank">Zentrale für KI-Richtlinien an Universitäten</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-4 col-12">
                                <div class="footer-widget">
                                    <h3>Compliances Covered</h3>
                                    <ul class="complianceCovered">
                                        <li>
                                            <img src="assets/images/compliance-certificates/Hipaa-logo.svg" width="119" height="119" alt="Hippa" />
                                        </li>
                                        <li>
                                            <img src="assets/images/compliance-certificates/EU_AI_Act.png" width="113" height="112" alt="EU AI Act" />
                                        </li>
                                        <li>
                                            <img src="assets/images/compliance-certificates/AICPA_SOC.png" width="113" height="112" alt="AICPA - SOC" />
                                        </li>
                                        <li>
                                            <img src="assets/images/compliance-certificates/gdpr.svg" width="113" height="112" alt="GDPR" />
                                        </li>
                                        <li>
                                            <img src="assets/images/compliance-certificates/information-security-management-system.svg" width="113" height="112" alt="iso 270001:2013 information security certificate" />
                                        </li>
                                        <li>
                                            <img src="assets/images/compliance-certificates/quality-management-system.svg" width="113" height="112" alt="iso 9001:2015 quality certificate" />
                                        </li>
                                        <li>
                                            <img src="assets/images/compliance-certificates/ada.svg" width="113" height="112" alt="ada certificate" />
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-middle section-pd-sm pb-20">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="footer-widget">
                        <h3>Unterstützt von:</h3>
                        <div class="media">
                            <div class="media-left">
                                <img src="assets/images/enago-logo.png" alt="enago logo" width="140" height="40" />
                            </div>
                            <div class="media-body">
                                <p>Enago ist ein renommierter Anbieter von Autoren-Dienstleistungen für die globale Forschungsgemeinschaft und unterstützt Forscher in über 125 Ländern dabei, ihre Forschungsergebnisse besser zu vermitteln und erfolgreiche Veröffentlichungen zu erzielen.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="footer-widget">
                        <h3>Angebotene Dienstleistungen:</h3>
                        <ul class="ftr-menu ftr-services">
                            <li>
                                <a href="https://www.enago.com/" target="_blank">Englische Textkorrektur</a>
                            </li>
                            <li>
                                <a href="https://www.enago.com/publication-support-services" target="_blank">Unterstützung bei der Veröffentlichung</a>
                            </li>
                            <li>
                                <a href="https://www.ulatus.com/" target="_blank">Übersetzungsagentur</a>
                            </li>
                            <li>
                                <a href="https://www.enago.com/plagiarism-checker/" target="_blank">Plagiats- und automatische Grammatikprüfung</a>
                            </li>
                            <li>
                                <a href="https://www.voxtab.com/" target="_blank">Transkriptions- und Untertitelungsdienste</a>
                            </li>
                            <li>
                                <a href="https://lifesciences.enago.com/" target="_blank">Globale medizinische Kommunikation</a>
                            </li>
                            <li>
                                <a href="https://www.read.enago.com/" target="_blank">Tool zur Literaturrecherche und -analyse</a>
                            </li>
                            <li>
                                <a href="https://www.charlesworth-group.com/" target="_blank">Agentur für digitales Marketing</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="footer-copyright">
            <div class="cp-left align-items-center">
                <p>© Crimson AI, {{ latestYear }}. Made in India.</p>
                <ul class="align-items-center">
                    <li>
                        <a href="mailto:support@trinka.ai">support&#64;trinka.ai</a>
                    </li>
                    <li>
                        <a id="PrivacyButton" href='https://www.trinka.ai/privacypolicy' target="_blank">Privacy Policy</a>
                    </li>
                    <li>
                        <a id="termsofserviceButton" href='https://www.trinka.ai/termsofservices' target="_blank">Terms of Services</a>
                    </li>
                </ul>
            </div>
            <div class="cp-right">
                <div class="footer-widget mb-0 follow-us">
                    <h3 class="mb-0">Follow Us:</h3>
                    <ul class="align-items-center">
                        <li>
                            <a href="https://www.facebook.com/thetrinkaai/" rel=" no referer, no opener" aria-label="facebook" target="_blank">
                                <img src="assets/images/social-media/facebook.svg" width="15" height="15" alt="facebook" />
                            </a>
                        </li>
                        <li>
                            <a href="https://www.instagram.com/thetrinkaai/" rel=" no referer, no opener" aria-label="instagram" target="_blank">
                                <img src="assets/images/social-media/instagram.svg" width="15" height="15" alt="instagram" />
                            </a>
                        </li>
                        <li>
                            <a href="https://x.com/thetrinkaai" rel=" no referer, no opener" aria-label="twitter" target="_blank">
                                <img src="assets/images/social-media/twitter-logo.svg" width="15" height="14" alt="twitter" />
                            </a>
                        </li>
                        <li>
                            <a href="https://www.linkedin.com/company/thetrinkaai" rel=" no referer, no opener" aria-label="linkedin" target="_blank">
                                <img src="assets/images/social-media/linkedin.svg" width="15" height="15" alt="linkedin" />
                            </a>
                        </li>
                        <li>
                            <a href="https://www.youtube.com/channel/UC1PNKZCxdUArpPVr5YFaYcA" rel=" no referer, no opener" aria-label="youtube" target="_blank">
                                <img src="assets/images/social-media/youtube.svg" width="15" height="15" alt="youtube" />
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="language_sections" id="languageDropDown">
                    <img src="assets/images/icons/globe.svg" width="14" height="14" alt="Globe" />
                    <span>Deutsch</span>
                    <ul class="drop">
                        <li class="selected">
                            <img src="assets/images/icons/checkmark.svg" width="14" height="14" alt="icon" />
                            <a href="https://www.trinka.ai/de/" lang="de">Deutsch</a>
                            
                        </li>
                        <li>
                            <a href="https://www.trinka.ai/">English</a>
                        </li>
                        <li>
                            <a href="https://www.trinka.ai/jp/">
                                日本語
                            </a>
                        </li>
                        <li>
                            <a href="https://trinka.enago.cn/">
                                简体中文
                            </a>
                        </li>
                        <li>
                            <a href="https://www.trinka.ai/tw/">
                                繁體中文
                            </a>
                        </li>
                        <li>
                            <a href="https://www.trinka.ai/kr/">
                                한국어
                            </a>
                        </li>
                        <li>
                            <a href="https://www.trinka.ai/es/">
                                Español
                            </a>
                        </li>
                        <li>
                            <a href="https://www.trinka.ai/pt/">
                                Português
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</footer>